import { Box, Typography } from "@mui/material"
import { faClock, faUserTie, faBuilding, faLocationDot } from "@fortawesome/pro-regular-svg-icons"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { MeetingOrderOrganizer } from "../../meetings/meetingTypes"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { getHostOrganizer, getHostOrganizerName } from "../meetigs/helpers"
import { useState } from "react"

import { HostContactDetailsDialog } from "./HostContactDetailsDialog"

const useStyles = makeStyles()(() => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
    },
    detailRow: {
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
    },
    icon: {
        color: tailwindPalette.slate[400],
        width: "1rem",
    },
    infoButton: {
        cursor: "pointer",
        marginLeft: ".5rem",
        color: tailwindPalette.slate[500],
        ":hover": {
            color: tailwindPalette.slate[400],
        },
    },
}))

type MeetingDetailsProps = {
    time?: string
    location?: string
    companyName?: string
    organizers?: Array<MeetingOrderOrganizer>
}

export function MeetingDetails({ time, location, companyName, organizers }: MeetingDetailsProps) {
    const { classes } = useStyles()
    const [isUserDetailsDialog, openDialog] = useState(false)

    const hostOrganizer = getHostOrganizer(
        organizers?.map((organizer) => ({
            ...organizer,
            type: organizer.organizerType,
        })),
    )

    return (
        <Box className={classes.container}>
            <Box className={classes.detailRow}>
                <FontAwesomeIcon icon={faUserTie} className={classes.icon} />
                <Typography>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-host">
                        <Typography component="span" variant="subtitle1">
                            Host:
                        </Typography>
                    </LocalizedStrict>{" "}
                    {getHostOrganizerName(
                        organizers?.map((organizer) => ({
                            name: organizer.name,
                            type: organizer.organizerType,
                            email: organizer.email,
                        })),
                    )}
                    {hostOrganizer && (
                        <FontAwesomeIcon
                            onClick={() => openDialog(true)}
                            className={classes.infoButton}
                            icon={faInfoCircle}
                        />
                    )}
                </Typography>
            </Box>
            <HostContactDetailsDialog
                isOpen={isUserDetailsDialog}
                host={hostOrganizer}
                onClose={() => openDialog(false)}
            />
            <Box className={classes.detailRow}>
                <FontAwesomeIcon icon={faBuilding} className={classes.icon} />
                <Typography>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-host-company">
                        <Typography component="span" variant="subtitle1">
                            Company:
                        </Typography>
                    </LocalizedStrict>{" "}
                    {companyName}
                </Typography>
            </Box>
            <Box className={classes.detailRow}>
                <FontAwesomeIcon icon={faClock} className={classes.icon} />
                <Typography>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-meeting-time">
                        <Typography component="span" variant="subtitle1">
                            Meeting time:
                        </Typography>
                    </LocalizedStrict>{" "}
                    {time}
                </Typography>
            </Box>
            <Box className={classes.detailRow}>
                <FontAwesomeIcon icon={faLocationDot} className={classes.icon} />
                <Typography>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-location">
                        <Typography component="span" variant="subtitle1">
                            Location:
                        </Typography>
                    </LocalizedStrict>{" "}
                    {location}
                </Typography>
            </Box>
        </Box>
    )
}
